<div class="more-list-wrapper">
    <div
        class="more-list"
        data-cy="channels-kebab-menu-delete"
        (click)="delete($event)"
        [class.disabled]="disableOptions || disableDelete">
        {{ 'channel.more-option.delete' | translate }}
    </div>
    <div
        class="more-list"
        data-cy="channels-kebab-menu-duplicate"
        (click)="duplicate($event)"
        [class.disabled]="disableOptions || disableDuplicate">
        {{ 'channel.more-option.duplicate' | translate }}
    </div>
    <div class="more-list" data-cy="channels-kebab-menu-edit" (click)="edit($event)" [class.disabled]="disableOptions">
        {{ 'channel.more-option.edit' | translate }}
    </div>
</div>
